import { render, staticRenderFns } from "./addDriver.vue?vue&type=template&id=456d2bd4&scoped=true&"
import script from "./addDriver.vue?vue&type=script&lang=js&"
export * from "./addDriver.vue?vue&type=script&lang=js&"
import style0 from "./addDriver.vue?vue&type=style&index=0&id=456d2bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d2bd4",
  null
  
)

export default component.exports